<template>
  <b-row class="grab">
    <b-col class="col-main-pad">
      <b-row>
        <b-col lg="12" class="col-head-activity">
          <font-awesome-icon icon="paw" />&nbsp; Configurar Animales
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <label for="name">Instrucciones de la Actividad</label>
            <b-form-textarea
              v-model="instrucciones"
              placeholder="Ingrese las Instrucciones para Realizar la Actividad"
              rows="2"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
  </b-row>
</template>
<script>
import OptionsElement from "./OptionsElement";
export default {
  name: "Animales",
  data() {
    return {
      instrucciones: this.desc,
      defaultSelected: null
    };
  },
  props: {
    palabras: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    desc: { type: String },
    idElement: { type: Number },
    idColumn: { type: Number, default: null }
  },
  components: {
    OptionsElement
  },
  watch: {
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>